import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./font.css";
import "./design-system/hpoint/index.css";
import App from "./App";
import BarcodeRegistrationApp from "./BarcodeRegistrationApp";
import reportWebVitals from "./reportWebVitals";

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
const Application = process.env.REACT_APP_BARCODE_REGISTRATION_ONLY === "true" ? BarcodeRegistrationApp : App;
root.render(
  // <React.StrictMode>
  <Application />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
